console.log('js/microconversions.js -> v0.1.0');
$(function() {

	if(Number(Cookies.get('mc_howtobook')) != 1){
		$('.mc_howtobook').removeClass('hidden');
	};

	$('.mc_howtobook:not(".hidden")').each(function(){
		$(this).find('.mc__input_button').click(function(){
			var input = $(this).closest('.mc__wrapper').find('.mc__input_field');
			var email = $(input).val();
			if(validateEmail(email)){
				$.ajax({
					type: "POST",
					url: "/ufl-subscribe",
					data: {email: email},
					async: true,
				});
				fbq('track', 'CompleteRegistration');
				var tracking_id = $(this).closest('[data-tracking-id]').attr('data-tracking-id');
				gae('marketing',tracking_id+'--subscribed');
				var win = window.open('/static/rebrand/How to Book a Yoga Retreat.pdf', '_blank');
				win.focus();
				var success_msg = $(this).closest('[data-transtag-success]').attr('data-transtag-success');
				$(this).closest('.mc__form_wrapper').html('<div class="mc__title">'+success_msg+'</div>');
				Cookies.set('mc_howtobook',1);
			}else{
				$(input).css('background-color','#FFEBE9').css('color','red');
				$(input).on('change keyup',function(){
					$(this).css('background-color','').css('color','');
				});
			};
		});
		$(this).find('.mc__input_field').keyup(function(e){
			var code = e.keyCode || e.which;
			if(code == 13) {
				$(this).closest('.mc__wrapper').find('.mc__input_button').click();
			};
		});
	});
	setTimeout(function(){
		$('.mc_howtobook[data-tracking-id]:not(".hidden")').each(function(){
			var tracking_id = $(this).closest('[data-tracking-id]').attr('data-tracking-id');
			gae('marketing',tracking_id+'--loaded');
			window.mc_visibility_interval = window.mc_visibility_interval || [];
			window.mc_visibility_interval[tracking_id] = setInterval(function(){
				var el = $('[data-tracking-id="'+tracking_id+'"]');
				var top_of_element = $(el).offset().top;
				var bottom_of_element = $(el).offset().top + $(el).outerHeight();
				var bottom_of_screen = $(window).scrollTop() + window.innerHeight;
				var top_of_screen = $(window).scrollTop();
				if((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
					gae('marketing',tracking_id+'--seen');
					clearInterval(window.mc_visibility_interval[tracking_id]);
				};
			},500);
		});
	},1000);
});

function validateEmail(email) {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(String(email).toLowerCase());
};
